import Breadcrumb from "components/Common/Breadcrumb"
import TableContainer from "components/Common/DataTableContainer"
import DashboardLoader from "components/Loader/DashboardLoader"
import DeleteModal from "pages/Calendar/DeleteModal"
import React, { useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { toast } from "sonner"
import {
  useGetAllClientsQuery,
  useDeleteClientMutation,
} from "store/features/client/clientManagementApi"
import { useGetAllProjectsQuery } from "store/features/client/clientManagementApi"
import CreateProjectModal from "components/Modals/CreateProjectModal"
import EditClientModal from "components/Modals/EditClientModal"
import { useSelector } from "react-redux"
import { selectUser } from "store/features/auth/authSlice"

const AllClients = () => {
  const user = useSelector(selectUser)
  const { data: clients, isLoading, refetch } = useGetAllClientsQuery()
  const { data: projects = [] } = useGetAllProjectsQuery()
  const [deleteClient, { isLoading: deletingClient }] =
    useDeleteClientMutation()

  const [modalOpen, setModalOpen] = useState(false)
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [selectedClient, setSelectedClient] = useState(null)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedClientId, setSelectedClientId] = useState(null)

  const toggleModal = () => setModalOpen(!modalOpen)
  const toggleEditModal = () => setEditModalOpen(!editModalOpen)

  const showDeleteModal = id => {
    setSelectedClientId(id)
    setDeleteModal(true)
  }

  const handleDeleteClient = () => {
    deleteClient(selectedClientId)
    setDeleteModal(false)
  }

  const handleCreateProject = client => {
    setSelectedClient(client)
    setModalOpen(true)
  }

  const handleEditClient = client => {
    setSelectedClient(client)
    setEditModalOpen(true)
  }

  const handleClientUpdate = () => {
    refetch()
    setEditModalOpen(false)
    toast.success("Client updated successfully")
  }

  const getClientProjects = clientId => {
    return projects.filter(project => project.client === clientId)
  }

  const columns = useMemo(
    () => [
      {
        header: "Client Name",
        accessorKey: "client_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Company Name",
        accessorKey: "company_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Email",
        accessorKey: "client_email",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Contact Number",
        accessorKey: "contact_number",
        enableColumnFilter: false,
        enableSorting: true,
      },
      // {
      //   header: "Address",
      //   accessorKey: "address",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => row.original.address || "N/A",
      // },
      // {
      //   header: "Contact Person",
      //   accessorKey: "contact_person",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => row.original.contact_person || "N/A",
      // },
      // {
      //   header: "Gender",
      //   accessorKey: "gender",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) =>
      //     row.original.gender
      //       ? row.original.gender.charAt(0).toUpperCase() +
      //         row.original.gender.slice(1)
      //       : "N/A",
      // },
      // {
      //   header: "Projects",
      //   accessorKey: "projects",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: ({ row }) => {
      //     const clientProjects = getClientProjects(row.original.id)
      //     return clientProjects.length
      //   },
      // },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          const clientProjects = getClientProjects(row.original.id)
          const hasProjects = clientProjects.length > 0

          return (
            <div className="d-flex align-items-center gap-1">
              <button
                onClick={() => handleCreateProject(row.original)}
                className="btn btn-success btn-sm"
              >
                <i className="fas fa-plus"></i>
              </button>

              <button
                onClick={() => handleEditClient(row.original)}
                className="btn btn-primary btn-sm"
              >
                <i className="fas fa-edit"></i>
              </button>

              <button
                className="btn btn-danger btn-sm"
                onClick={() => showDeleteModal(row.original.id)}
              >
                <i className="fas fa-trash"></i>
                {/* {deletingClient ? "Deleting..." : "Delete"} */}
              </button>
            </div>
          )
        },
      },
    ],
    [projects, deletingClient]
  )

  if (isLoading) {
    return <DashboardLoader />
  }

  return (
    <div className="page-content">
      <div className="container-fluid">

        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
  
  {/* Breadcrumb Section */}
  <div>
    <Breadcrumb title="Clients" breadcrumbItem="Clients" />
  </div>

  {/* Action Buttons */}
  <div className="d-flex flex-wrap gap-2">
    
    <Link
      to="/create-client"
      className="btn btn-primary d-flex align-items-center px-3"
    >
      <i className="fas fa-plus me-2"></i>
      Add Client
    </Link>

    <Link
      to="/all-projects"
      className="btn btn-outline-primary d-flex align-items-center px-3"
    >
      <i className="fas fa-folder-open me-2"></i>
      Projects
    </Link>

    <Link
      to="/all-invoices"
      className="btn btn-outline-success d-flex align-items-center px-3"
    >
      <i className="fas fa-file-invoice-dollar me-2"></i>
      Invoices
    </Link>

    <Link
      to="/all-money-receipt"
      className="btn btn-outline-dark d-flex align-items-center px-3"
    >
      <i className="fas fa-receipt me-2"></i>
      Money Receipts
    </Link>

  </div>
</div>

        <TableContainer
          columns={columns}
          data={clients || []}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder="Search Clients..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />


        {selectedClient && (
          <CreateProjectModal
            isOpen={modalOpen}
            toggle={toggleModal}
            clientId={selectedClient.id}
            clientName={selectedClient.company_name}
          />
        )}

        {selectedClient && (
          <EditClientModal
            isOpen={editModalOpen}
            toggle={toggleEditModal}
            client={selectedClient}
            onClientUpdate={handleClientUpdate}
          />
        )}

        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteClient}
          loader={deletingClient}
          onCloseClick={() => setDeleteModal(false)}
        />
      </div>
    </div>
  )
}

export default AllClients
